import { IconButtonComponent } from "../components/icon-button/icon-button.component";
import { ButtonService } from '../services/button.service';
import { ActionGroupComponent } from '../components/action-group/action-group.component';

export class ToggleGroup {
	private buttons: Array<IconButtonComponent>;
	private buttonService: ButtonService;
	private selectedButton: IconButtonComponent;
	private actionGroup: ActionGroupComponent;

	get selectedTitle(): string {
		return this.selectedButton.title;
	}
	constructor() {
		this.buttons = [];
	}

	AddButton(button: IconButtonComponent, service: ButtonService, actionGroup: ActionGroupComponent) {
		this.actionGroup = actionGroup;
		this.buttons.push(button);
		button.btn.nativeElement.addEventListener('click', () => {
			this.Select(button);
		});
		if (!this.buttonService) {
			this.buttonService = service;
		}

	}

	Select(targetButton: IconButtonComponent) {
		this.selectedButton = targetButton;
		for (const button of this.buttons) {
			if (button !== targetButton) {
				//this.actionGroup.HandleActionButton(targetButton);
				this.buttonService.ToggleButton(button.btn.nativeElement, false);
				$(button.btn.nativeElement).toggleClass('toggleable-unselected', true);
			} else {
				$(button.btn.nativeElement).toggleClass('toggleable-unselected', false);
			}
		}
	}
}
